import { render, staticRenderFns } from "./PershingJointAccountInfo.vue?vue&type=template&id=5b3dfff6&scoped=true"
import script from "./PershingJointAccountInfo.vue?vue&type=script&lang=js"
export * from "./PershingJointAccountInfo.vue?vue&type=script&lang=js"
import style0 from "./PershingJointAccountInfo.vue?vue&type=style&index=0&id=5b3dfff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3dfff6",
  null
  
)

export default component.exports